export class DocumentTypes
{
    static PRODUCT_BALANCING = 'PB';
    static PAYOUT_STATEMENT = 'PO';
}

export class Usertype
{
    static SENDER = 'sender'
    static RECEIVER = 'receiver'
}

export class UserRole
{
    static ADMIN = 1
    static OWNER = 2
    static USER = 3
    static API = 4
}